var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSearchZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11.01c0 4.97 4.04 9.01 9.01 9.01s9.01-4.04 9.01-9.01S15.98 2 11.01 2 2 6.04 2 11.01zm9.75.74v1.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.75H8.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.75V8.5c0-.41.34-.75.75-.75s.75.34.75.75v1.75h1.75c.41 0 .75.34.75.75s-.34.75-.75.75h-1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.02 18c-.71 0-1.32.29-1.68.79-.36.5-.44 1.17-.22 1.84.43 1.3 1.18 1.59 1.59 1.64.06.01.12.01.19.01.44 0 1.12-.19 1.78-1.18.53-.77.63-1.54.31-2.15-.33-.61-1.03-.95-1.97-.95z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSearchZoomIn);
export default __webpack_public_path__ + "static/media/vuesax-bold-search-zoom-in.4586414d0e61cba1bfa1f8196c260d43.svg";
export { ForwardRef as ReactComponent };